import { capturePostHog } from "@/lib/analytics/posthog";

type Surface = "bell" | "page";
type Action = "open" | "mark_read" | "mark_all_read";

// Properties are the surface and action only; no ids, titles or categories.
export function trackNotifications(surface: Surface, action: Action) {
  capturePostHog("client_notifications", { surface, action });
}
